<template>
  <div>
    <!-- 根据设备类型动态渲染对应的组件 -->
    <HomeViewDesktop v-if="!isMobile" />
    <HomeViewMobile v-else />
  </div>
</template>

<script>
import HomeViewDesktop from './HomeViewDesktop.vue'
import HomeViewMobile from './HomeViewMobile.vue'

export default {
  name: 'HomeView',
  components: {
    HomeViewDesktop,
    HomeViewMobile
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
    }
  },
  mounted() {
    this.initResizeHandler();
  },
  beforeDestroy() {
    this.cleanupEventListeners();
  },
  methods: {
    // 初始化窗口大小变化处理器
    initResizeHandler() {
      this.resizeHandler = this.debounce(() => {
        this.isMobile = window.innerWidth <= 768;
      }, 250);
      
      window.addEventListener('resize', this.resizeHandler);
    },
    
    // 清理事件监听器
    cleanupEventListeners() {
      window.removeEventListener('resize', this.resizeHandler);
    },
    
    // 防抖函数
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
  },
}
</script>

<style scoped>
/* 主容器样式 */
</style>

